import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export default function ScrollToTop() {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    // If there is no hash in the URL, reset scroll to the very top (0,0)
    if (!hash) {
      window.scrollTo(0, 0)
    } else {
      // If there is an anchor hash, wait a brief moment for the DOM to render/mount
      // and then scroll smoothly to the element
      const timer = setTimeout(() => {
        const element = document.getElementById(hash.substring(1))
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      }, 100)

      return () => clearTimeout(timer)
    }
  }, [pathname, hash])

  return null
}
